import { CompetitorVsPage } from '../../components/comparisons/CompetitorVsPage';
import { getCompetitorComparison } from '../../data/competitor-comparisons';
import { COMPETITOR_PRICING, COMPETITOR_PRICING_MAX_AGE_DAYS } from '../../data/competitor-pricing';
import { warnStaleEntries } from '../../data/pseo/staleness';
import { isPublishable } from '../../data/pseo/types';

const entry = getCompetitorComparison('frame-io-vs-filestage');

export default function FrameIoVsFilestagePage() {
  return (
    <CompetitorVsPage
      entry={entry}
      documentTitle="Frame.io vs Filestage (2026): Features & Pricing"
      metaDescription="Frame.io vs Filestage compared: file types, Premiere Pro integrations, guest review, approvals, per-member vs flat pricing, and free plans."
      h1="Frame.io vs Filestage"
      heroText="A video-first review tool priced per member against a flat-priced proofing platform, compared on official facts."
      publishDate="2026-10-22 00:00"
      readTimeMinutes="7"
      coverSrc="/images/comparisons/filestage-alternatives-2026-cover.jpg"
      coverAlt="Frame.io vs Filestage comparison"
    />
  );
}

export function getStaticProps() {
  warnStaleEntries('competitor-comparisons', [entry], COMPETITOR_PRICING_MAX_AGE_DAYS);
  warnStaleEntries(
    'competitor-pricing',
    COMPETITOR_PRICING.filter((pricing) => pricing.id === entry.a || pricing.id === entry.b),
    COMPETITOR_PRICING_MAX_AGE_DAYS,
  );
  if (!isPublishable(entry)) {
    return { notFound: true };
  }
  return { props: {} };
}
